import { aitendersLogo, aitendersCroppedLogo, smacLogo, smacFullLogo } from "../resources/images";

/** Keep public/favicon.ico for automatic browser behavior as to not cause any 404 for this. */
const whiteLabelConfig = {
	main: {
		logo: aitendersLogo,
		croppedLogo: aitendersCroppedLogo,
		fullLogo: aitendersLogo,
		favicon: "/favicons/aitenders-favicon.ico",
		altText: "aitenders_logo",
	},
	smac: {
		logo: smacLogo,
		croppedLogo: aitendersCroppedLogo,
		fullLogo: smacFullLogo,
		favicon: "/favicons/aitenders-favicon.ico",
		altText: "smac_logo",
	},
};

const FALLBACK_ENV = "main";

export const getWhiteLabelConfig = () => {
	const env = window.env.REACT_APP_LOGO_ENV;
	return whiteLabelConfig[env] ?? whiteLabelConfig[FALLBACK_ENV];
};
